import { callApi } from "./api.service";

export const AddPaymentMethod = async (
  data: any,
  getToken: () => Promise<string | null>
) => {
  return await callApi("/api/add-payment-method", "POST", true, getToken, data);
};

export const GetPaymentMethod = async (
  getToken: () => Promise<string | null>
) => {
  return await callApi("/api/get-payment-method", "GET", true, getToken);
};

export const RemovePaymentMethod = async (
  data: any,
  getToken: () => Promise<string | null>
) => {
  return await callApi(
    "/api/remove-payment-method",
    "POST",
    true,
    getToken,
    data
  );
};

export const UpdatePaymentMethod = async (
  data: any,
  getToken: () => Promise<string | null>
) => {
  return await callApi(
    "/api/update-payment-method",
    "PUT",
    true,
    getToken,
    data
  );
};
